import eyeShow from "@/assets/AppIcons/eyeShow";
import eyeHidden from "@/assets/AppIcons/eyeHidden";
import checkMarkCircle from "@/assets/AppIcons/checkMarkCircle";

const CustomIcons = {
  eyeShow: {
    component: eyeShow
  },
  eyeHidden: {
    component: eyeHidden
  },
  checkMarkCircle: {
    component: checkMarkCircle
  }
};

export default CustomIcons;
